enum FieldsTableColumnSize {
  Field = 28,
  Recipient = 23,
  Type = 20,
  Variable = 29,
}

export default FieldsTableColumnSize;
